<script>
import Label from '@/components(new)/UI/Forms/Label/Label.vue'
import Cadastrante from './Cadastrante/Cadastrante.vue'
import Proprietario from './Proprietario/Proprietario.vue'
import Imovel from './Imovel/Imovel.vue'
import UsoDoSolo from './UsoDoSolo/UsoDoSolo.vue'
import Praticas from './Praticas/Praticas.vue'
import Georreferenciamento from './Georreferenciamento/Georreferenciamento.vue'
import Galeria from './Galeria/Galeria.vue'
import * as serviceGeo from '@/services/georreferenciamento'
import axios from '@/utils/api'

export default {
  components: {
    Label,
    Cadastrante,
    Proprietario,
    Imovel,
    UsoDoSolo,
    Praticas,
    Georreferenciamento,
    Galeria
  },
  props: {
    cadastro: {
      type: Object
    },
    protocolo: {
      type: String
    },
    modalidadeCadastro: {
      type: String
    }
  },
  data () {
    return {
      activeNames: [],
      alreadyExpanded: [],
      dadosGeorreferenciamento: {
        loading: true,
        spsList: [],
        propertyShapeImovel: null,
        propertyShapePraticas: null
      },
      dadosGaleria: {
        loading: true,
        hasOutros: false
      }
    }
  },
  computed: {
    isCadastroEmpresa () {
      return this.modalidadeCadastro?.toUpperCase() === 'EMPRESA'
    }
  },
  methods: {
    async loadGeorreferenciamentoData () {
      this.dadosGeorreferenciamento.loading = true
      const { praticas, imovel } = await serviceGeo.getGeorreferenciamentoData(this.protocolo, false)
      this.dadosGeorreferenciamento.spsList = praticas
      this.dadosGeorreferenciamento.propertyShapeImovel = imovel
      this.dadosGeorreferenciamento.propertyShapePraticas = praticas
      this.dadosGeorreferenciamento.loading = false
    },
    async verifyIfHasFotoByType (tipo) {
      this.dadosGaleria.hasOutros = await axios({
        method: 'POST',
        url: 'foto/verify/exists/byType',
        data: { protocolo: this.protocolo, tipo },
        loader: false
      })
      this.dadosGaleria.loading = false
    },
    async handleChange (etapa) {
      if (!etapa || !etapa.length) return
      const lastInteract = etapa[etapa.length - 1]
      if (this.alreadyExpanded.includes(lastInteract)) return
      this.activeNames = etapa
      this.alreadyExpanded.push(lastInteract)
      if (lastInteract === 'GEORREFERENCIAMENTO') {
        await this.loadGeorreferenciamentoData()
      }
      if (lastInteract === 'GALERIA') {
        this.verifyIfHasFotoByType('OUTROS')
      }
    }
  }
}
</script>

<template>
  <div>
    <span class="title-cadastro">Dados do cadastro</span>
    <div class="container-collapse">
      <el-collapse @change="handleChange">
        <el-collapse-item title="Cadastrante" name="CASTRANTE">
          <Cadastrante  :cadastrante="cadastro.cadastrante" />
        </el-collapse-item>
        <el-collapse-item v-if="!isCadastroEmpresa" title="Proprietário" name="PROPRIETARIO">
          <Proprietario :proprietario="cadastro.proprietario" />
        </el-collapse-item>
        <el-collapse-item title="Imóvel" name="IMOVEL">
          <Imovel :imovel="cadastro.imovel" />
        </el-collapse-item>
        <el-collapse-item title="Uso do solo" name="USO_DO_SOLO">
          <UsoDoSolo :usoDoSolo="cadastro.usoSolo" />
        </el-collapse-item>
        <el-collapse-item title="Práticas" name="PRATICAS">
          <Praticas :praticas="cadastro.praticas" />
        </el-collapse-item>
        <el-collapse-item title="Georreferenciamento" name="GEORREFERENCIAMENTO">
          <Georreferenciamento :dados="dadosGeorreferenciamento" />
        </el-collapse-item>
        <el-collapse-item title="Galeria" name="GALERIA">
          <Galeria :cadastro="cadastro" :protocolo="protocolo" :dados="dadosGaleria" />
        </el-collapse-item>
      </el-collapse>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  @import './style.scss'
</style>



// WEBPACK FOOTER //
// src/components(new)/UI/Modals/VisualizacaoCadastro/Cadastro/Cadastro.vue